import React, { useEffect, useRef, useState } from "react";
import { Form } from "reactstrap";
import "./index.css";
import { Card, CardBody, CardHeader } from "react-bootstrap";
import DataTable, { TableColumn } from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import {
  useGetRestaurantSearchResultsMutation,
  useGetRestaurantsByStatusMutation,
} from "../../../redux/services/restaurantSearchService";
import StatusBadge from "../../../components/StatusBatch";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import ControlledSelectForFiltering from "../../../components/ContolledSelectForFiltering";
import ViewButtonComponent from "../../../components/ViewButtonComponent";
import BreadCrumbs from "../../../components/BreadCrumbs";
import { useDispatch, useSelector } from "react-redux";
import {
  setSearchData,
  setRestaurantRowsPerPage,
  setRestaurantsList,
  setRestaurantsStatus,
} from "../../../redux/restaurantSearchSlice";
import man from "../../../assets/icons/man.PNG";
import ControlledTextField from "../../../components/ControlledTextField";
import { RootState } from "../../../redux/store";
import TableLoadingComponent from "../../../components/TableLoadingComponent";
import { RESTAURANT_STATUS } from "../../../constants/constans";

export interface RestaurantData {
  id: string;
  restaurantId: string;
  documentId: string;
  imageUrl: string;
  displayName: string;
  restaurantName: string;
  address: string;
  status: string;
  category: string;
  openingTime: string;
  closingTime: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  admins: string[];
  bankAccountDetails?: {
    accountName: string;
    accountNumber: string;
    bankName: string;
    branchName: string;
    swiftCode: string;
    createdAt: {
      _seconds: number;
      _nanoseconds: number;
    };
  };
}

export type RestaurantStatusData = {
  restaurantStatus: { value: string; label: string };
  searchRest: string;
};

const Restaurants: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [initialList, setInitialList] = useState<RestaurantData[]>([]);
  const [restaurantList, setRestaurantList] = useState<RestaurantData[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchTextConfirm, setSearchTextConfirm] = useState(false);
  const typingTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isChangeText, setIsChangeText] = useState(false);
  const [ifReset, setIfReset] = useState(false);
  const searchData = useSelector(
    (state: RootState) => state.restaurantSearch.searchData
  );
  const rowsPerPage = useSelector(
    (state: any) => state.restaurantSearch.restaurantRowsPerPage
  );
  const restaurantStatus = useSelector(
    (state: RootState) => state.restaurantSearch.restaurantsStatus
  );

  const [triggerRestaurantSearchList] = useGetRestaurantSearchResultsMutation();

  const [triggerRestaurantList, { isLoading }] =
    useGetRestaurantsByStatusMutation();

  const { control, handleSubmit, watch, setValue } =
    useForm<RestaurantStatusData>({
      defaultValues: {
        restaurantStatus: restaurantStatus,
        searchRest: searchData,
      },
    });

  const searchRestWatcher = watch("searchRest");
  const restaurantStatusWatcher = watch("restaurantStatus");

  const handleSearch = async () => {
    setIsSearchActive(true);
    if (isChangeText === true) {
      const obj = {
        params: `query=${searchRestWatcher}`,
      };
      try {
        setIsSearchLoading(true);
        const response: any = await triggerRestaurantSearchList(obj);
        if (response?.data) {
          const availableRest = response?.data?.hits.filter(
            (item: RestaurantData) => {
              if (restaurantStatusWatcher?.label === "All") {
                return item.status != null;
              } else {
                return item.status === restaurantStatusWatcher?.label;
              }
            }
          );
          setRestaurantList(availableRest);
          if (Array.isArray(response?.data?.hits)) {
            setInitialList(response?.data?.hits);
          } else {
            setInitialList([]);
          }
          setIsChangeText(false);
          dispatch(setRestaurantsList(response?.data?.hits));
        } else if (response?.errors) {
          toast.error("Something went wrong...! Please try again.");
        }
        setIsSearchLoading(false);
      } catch (error) {
        setIsSearchLoading(false);
      }
    } else {
      const availableRest = (initialList || []).filter(
        (item: RestaurantData) => {
          if (restaurantStatusWatcher?.label === "All") {
            return item.status != null;
          } else {
            return item.status === restaurantStatusWatcher?.label;
          }
        }
      );
      setRestaurantList(availableRest);
    }
  };

  const handleFilterStatusWise = async () => {
    const obj = {
      restaurantStatus: restaurantStatusWatcher.label,
    };

    try {
      const response: any = await triggerRestaurantList(obj);
      if (response?.data) {
        setRestaurantList(response?.data);
        if (restaurantStatusWatcher?.label === "All") {
          dispatch(setRestaurantsList(response?.data));
        }
        if (searchRestWatcher.length) {
          setValue("searchRest", "");
        }
      } else if (response?.errors) {
        toast.error("Something went wrong...! Please try again.");
      }
      setIsSearchLoading(false);
    } catch (error) {
      toast.error("Something went wrong...! Please try again");
      setIsSearchLoading(false);
    }
  };

  const handleSearchTextConfirm = () => {
    if (typingTimer.current) clearTimeout(typingTimer.current);
    setSearchTextConfirm(false);

    if (searchRestWatcher.length) {
      typingTimer.current = setTimeout(() => {
        setIsSearchLoading(true);
      }, 1500);
      typingTimer.current = setTimeout(() => {
        setSearchTextConfirm(true);
      }, 3000);
    }

    return () => {
      if (typingTimer.current) {
        clearTimeout(typingTimer.current);
      }
    };
  };

  useEffect(() => {
    if (searchRestWatcher.length < 4 && searchRestWatcher.length !== 0) {
      handleFilterStatusWise();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantStatusWatcher]);

  useEffect(() => {
    if (searchRestWatcher.length > 3) {
      handleSearchTextConfirm();
    } else if (searchRestWatcher.length === 0 && ifReset) {
      handleFilterStatusWise();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchRestWatcher, restaurantStatusWatcher]);

  useEffect(() => {
    if (searchTextConfirm) {
      handleSearch();
      setIsSearchLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextConfirm]);

  useEffect(() => {
    if (!searchData) {
      handleFilterStatusWise();
      setIfReset(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchRestWatcher) {
      setIsChangeText(true);
      setIfReset(true);
    } else {
      setIsChangeText(false);
    }
    dispatch(setSearchData(searchRestWatcher));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchRestWatcher]);

  useEffect(() => {
    dispatch(setRestaurantsStatus(restaurantStatusWatcher));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantStatusWatcher]);

  const onSubmit = async (formData: RestaurantStatusData) => { };

  const handleViewRestaurantDetails = (restaurant: RestaurantData) => {
    const queryParams = new URLSearchParams();
    queryParams.set("status", restaurantStatusWatcher.value);
    navigate(
      `/restaurants/restaurants-list/view?${queryParams.toString()}`,
      {
        state: { restaurant },
      }
    );
    setIfReset(true);
  };

  const handleChangeRowsPerPage = (newRowsPerPage: number) => {
    dispatch(setRestaurantRowsPerPage(newRowsPerPage));
  };

  const columns: TableColumn<RestaurantData>[] = [
    // {
    //   name: <h6 className="fw-bold">#</h6>,
    //   cell: (row, rowIndex) => rowIndex + 1 + (currentPage - 1) * rowsPerPage,
    //   sortable: true,
    //   width: "7%",
    // },
    //Added Comment
    {
      name: <h6 className="fw-bold">Photo</h6>,
      selector: (row) => row.imageUrl,
      cell: (row) => (
        <img
          src={row.imageUrl || man}
          alt={row.displayName}
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "10px",
            margin: "5px",
          }}
          onError={(e) => {
            e.currentTarget.src = man;
          }}
        />
      ),
      sortable: false,
    },
    {
      name: <h6 className="fw-bold">Name</h6>,
      cell: (row) => (
        <div
          className="d-flex gap-2"
          style={{
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          {row?.displayName || row?.restaurantName}
        </div>
      ),
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Status</h6>,
      cell: (row) => <StatusBadge status={row.status} />,
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Action</h6>,
      selector: (row) => "action",
      cell: (row) => (
        <div className="d-flex gap-2">
          &nbsp;
          <ViewButtonComponent
            onClick={() => handleViewRestaurantDetails(row)}
          />
        </div>
      ),
      sortable: false,
      right: true,
    },
  ];

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <div>
        <Form
          className="auth-login-form mt-2"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="d-flex align-items-end justify-content-between gap-3 flex-wrap">
            <div><h4>Restaurants</h4></div>
            <div style={{ minWidth: "300px" }}>
              <ControlledTextField
                label={
                  <span>
                    Search Restaurants{" "}
                    {isSearchLoading && (
                      <span className="loading-text">
                        {"  "}
                        Please Wait...
                      </span>
                    )}
                  </span>
                }
                inputName="searchRest"
                inputType="text"
                control={control}
                placeholder="Enter at least 4 characters"
                onBlur={() => setIsSearchActive(false)}
                className="custom-input"
                isDisabled={isLoading}
              />
            </div>

            <div style={{ minWidth: "300px" }}>
              <ControlledSelectForFiltering
                label="Restaurant Status"
                inputName="restaurantStatus"
                control={control}
                optionsList={RESTAURANT_STATUS}
                className="custom-input"
                isDisabled={isLoading}
              />
            </div>
          </div>

          <Card>
            <CardHeader className="restaurant-search-card-header">
              <div className="d-flex justify-content-between p-2">
                <h5 className="">Restaurants</h5>
              </div>
              <hr />
            </CardHeader>
            <CardBody>
              {isLoading ? (
                <div className="bg-white">
                  <TableLoadingComponent numColumns={4} />
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={restaurantList}
                  responsive
                  pagination
                  highlightOnHover
                  pointerOnHover
                  paginationPerPage={rowsPerPage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  noDataComponent={<div>No Restaurants found</div>}
                />
              )}
            </CardBody>
          </Card>
        </Form>
      </div>
    </>
  );
};

export default Restaurants;
